// extracted by mini-css-extract-plugin
export default {"container":"tooltip-component_container__pQ3Ov","truncate-table":"tooltip-component_truncate-table__V+vGf","table-text-faded":"tooltip-component_table-text-faded__6doGD","tooltip":"tooltip-component_tooltip__Hzt-I"};
    if(module.hot) {
      // 1793877080926
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  